import React from 'react';
import pt from 'prop-types';
import Container from '/src/modules/container';
import Text from '/src/components/ui/text';
import { combine } from '../../../helpers/styles';
import CMSForm, {
  proptypes as formProps,
} from '/src/components/cms-modules/form';
import Image, { imageProptypes } from '../../ui/image';
import Link, { linkProptypes } from '../../ui/link';
import * as styles from './separator.module.scss';
import { ifWordLetterLowercase } from '../../../helpers/copy';

const CMSSeparator = ({
  textAboveHeadline,
  title: { headline },
  backgroundImage,
  ctas,
  form,
  backgroundColor,
  image,
}) => {
  const renderImage = () => {
    return (
      <Image
        image={backgroundImage.image}
        className={combine(styles.backgroundImage)}
        focusPoint={backgroundImage.focusPoint}
      />
    );
  };

  const hasForm = form ? Object.keys(form).length > 0 : false;
  const hasCtas = ctas ? ctas.length > 0 : false;

  const renderSecondColumn = () => {
    // preference is image > ctas > form
    if (image?.image) {
      return (
        <Image image={image.image} className={styles.secondColumnContent} />
      );
    }

    return !hasForm ? (
      <div className={styles.ctaWrapper}>
        {ctas?.map((cta, index) => (
          <div key={index}>
            <Link
              link={cta}
              asButton
              allowIcon
              className={styles.secondColumnContent}
            >
              {cta.text}
            </Link>
          </div>
        ))}
      </div>
    ) : (
      <div className={styles.inputWrapper}>
        <CMSForm
          inputPlaceholder={form.inputPlaceholder}
          btnLabel={form.btnLabel}
          type={form.type}
          inputClassName={styles.separatorInput}
          btnClassName={styles.inputCta}
          className={styles.form}
          action={form.action}
          gaTrackingKeyword={form.gaTrackingKeyword}
        />
      </div>
    );
  };

  return (
    <div
      className={combine(
        styles.separator,
        backgroundColor === 'red' && styles.isRed
      )}
    >
      {backgroundImage && renderImage()}
      <Container className={styles.innerContainer}>
        <div
          className={combine(
            styles.firstColumn,
            !hasForm && !hasCtas && styles.fullWidth
          )}
        >
          {textAboveHeadline && (
            <Text
              as="span"
              type="separator"
              variant="thin"
              className={styles.textAboveHeadline}
            >
              {textAboveHeadline}
            </Text>
          )}
          <Text as="pre" type="separator" className={styles.whiteText}>
            {ifWordLetterLowercase(headline)}
          </Text>
        </div>
        {(hasForm || hasCtas || image) && (
          <div
            className={combine(
              styles.secondColumn,
              !hasForm && styles.ctasContainer
            )}
          >
            {renderSecondColumn()}
          </div>
        )}
      </Container>
    </div>
  );
};

CMSSeparator.propTypes = {
  textAboveHeadline: pt.string,
  title: pt.shape({
    headline: pt.string.isRequired,
  }),
  ctas: pt.arrayOf(pt.shape(linkProptypes)),
  form: pt.shape(formProps),
  backgroundColor: pt.oneOf(['red', 'blue']),
  backgroundImage: pt.shape(imageProptypes),
};

CMSSeparator.defaultProps = {
  textAboveHeadline: '',
  title: '',
  ctas: [],
  backgroundColor: '',
  backgroundImage: '',
};

export default CMSSeparator;
